export const extensions = [
  {
    attributeName: null,
    url: "https://cdnjs.cloudflare.com/ajax/libs/dplayer/1.27.1/DPlayer.min.js",
    loaded: false,
  },
  {
    attributeName: "embedVideoDash",
    url: "https://cdnjs.cloudflare.com/ajax/libs/dashjs/4.7.0/dash.all.min.js",
    loaded: false,
  },
  {
    attributeName: "embedVideoFlv",
    url: "https://cdnjs.cloudflare.com/ajax/libs/flv.js/1.6.2/flv.min.js",
    loaded: false,
  },
  {
    attributeName: "embedVideoHls",
    url: "https://cdnjs.cloudflare.com/ajax/libs/hls.js/1.4.3/hls.min.js",
    loaded: false,
  },
  {
    attributeName: "embedVideoShaka",
    url: "https://cdnjs.cloudflare.com/ajax/libs/mux.js/6.3.0/mux.min.js",
    loaded: false,
  },
  {
    attributeName: "embedVideoShaka",
    url: "https://cdnjs.cloudflare.com/ajax/libs/shaka-player/4.3.6/shaka-player.compiled.js",
    loaded: false,
  },
  {
    attributeName: "embedVideoWebTorrent",
    url: "https://cdnjs.cloudflare.com/ajax/libs/webtorrent/1.9.7/webtorrent.min.js",
    loaded: false,
  },
];
